import { render, staticRenderFns } from "./blessingTemplate.vue?vue&type=template&id=a4040f38&scoped=true&"
import script from "./blessingTemplate.vue?vue&type=script&lang=js&"
export * from "./blessingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./blessingTemplate.vue?vue&type=style&index=0&id=a4040f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4040f38",
  null
  
)

export default component.exports